import angular from 'angular';

import PrivilegeItemComponent from './privilege-item-component';

export default angular.module('privilege-item', []).component('privilegeItem', new PrivilegeItemComponent());



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/components/privilege-item/privilege-item-module.js